<!-- <div *ngIf="products" class="swiper-container">
    <div class="swiper-wrapper h-100">
        <div *ngFor="let product of products" class="swiper-slide">
            <mat-card class="product-item">

                <a (click)="product['product'] && products['storeDetailsJson']['settings']['productFullView'] === true ? goToProduct(product, 'parent') : openProductDialog(product)"
                    class="image-link hand">
                    <img src="data:,"
                        [imgName]="!!product['product']['product_image1'] ? product['product']['product_image1'] : product['product']['product_image2']"
                        imgType="products" class="swiper-lazy hand" imgSize="sm" imagePreload
                        alt="{{product['product']['description']}}" />
                </a>
                <h4 class="category text-muted hand"
                    (click)="product['product'] && products['storeDetailsJson']['settings']['productFullView'] === true ? goToProduct(product, 'parent') : openProductDialog(product)">
                    {{ product['product']['cb_category']['category_name'] }}</h4>
                <a (click)="product['product'] && storeDetailsJson['settings']['productFullView'] === true ? goToProduct(product, 'parent') : openProductDialog(product)"
                    class="title text-truncate hand">
                    {{product['product']['description']}}
                </a>
                <div fxLayout="row"
                    (click)="product['product'] && products['storeDetailsJson']['settings']['productFullView'] === true ? goToProduct(product, 'parent') : openProductDialog(product)"
                    fxLayoutAlign="space-between center" class="prices hand">
                    <div fxLayout="row" fxLayoutAlign="center start" class="hand">
                        <p class="new-price hand">
                            {{store['currency']}}{{product['product'].retail_price | number: '1.2-2'}}</p>
                        <p class=" text-muted pd-l-5  hand" *ngIf="product['product'].compare_price"><span
                                class="old-price">{{store['currency']}}{{product['product'].compare_price | number: '1.2-2'}}</span>
                            Saved ({{product['product'].savepercentage}}%)</p>
                    </div>
                </div>
                <div class="divider mt-2"></div>
                <div class="icons">
                    <app-controls [store]="store" [product]="product"
                        (onOpenProductDialog)="openProductDialog(product)"></app-controls>
                </div>
            </mat-card>
        </div>
    </div>
    <div class="swiper-pagination"></div>

    <button mat-mini-fab class="swiper-button-prev swipe-arrow">
        <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-mini-fab class="swiper-button-next swipe-arrow">
        <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
</div> -->

<div *ngIf="products && products.length > 0" fxLayout="row wrap" class="products-wrapper">
    <div *ngFor="let product of products " fxFlex="100" fxFlex.gt-sm="25" fxFlex.lt-sm="100" class="col section-ht">
        <mat-card class="product-item text-center"
        [ngClass]="{'product-container-item': isFeatureTagShowTwoLineDescription}"
        >
            <div class="Probadges" [ngClass]="{ 'ProbadgeImgFit': FeatureTagProbadgeImgFit }">
                <ul>
                    <li *ngFor="let badge of product['product']['cb_product_badges']">
                        <img [src]="badge['cb_badge']['image'] | mapUrlForImg" alt="" >
                    </li>
                </ul>
            </div>
            <div class="sold-out" (click)="goToProduct(product, 'parent')" *ngIf="!!product['product']['stock_info'] && product['product']['stock_info']['restrict_orders'] == 1 && product['product']['stock_info']['stock_in_hand']==0">
                <img class="sold-out-img" src="assets/images/others/sold_out_icon.svg" imgType="products" ngClass.lt-md="sm" alt="sold out"/>
            </div>
            <a [routerLink]="getRouterLink(product)" [attr.href]="generateHref(product)" (click)="goToProduct(product, 'parent')" class="image-link hand">
                <img src="data:,"
                    [imgName]="!!product['product']['product_image1'] ? product['product']['product_image1'] : product['product']['product_image2']"
                    imgType="products" class="swiper-lazy hand" imgSize="md" imagePreload
                    alt="{{product['product']['description']}}" />
            </a>
            <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_show_two_line_description_in_product_card']">
                <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_manufacturer_list']">
                    <h4 class="category text-muted hand" (click)="goToProduct(product, 'parent')" *ngIf="product['product'] && (product['product']['manufacturer_name'] || product['product']['vendor_name'])">
                    {{ product['product']['manufacturer_name'] || product['product']['vendor_name'] }}
                    </h4>
                </ng-container>
                <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_manufacturer_list']">
                    <h4 class="category text-muted hand" (click)="goToProduct(product, 'parent')" *ngIf="!!product['product']['vendor_name']">
                        {{ product['product']['vendor_name'] }}</h4>
                </ng-container>
                <a [routerLink]="getRouterLink(product)" [attr.href]="generateHref(product)" (click)="goToProduct(product, 'parent')" class="title text-wrap-line hand">
                    {{product['product']['description']}}
                </a>
            </ng-container>
            <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_show_two_line_description_in_product_card']">
                <h4 class="category text-muted hand" (click)="goToProduct(product, 'parent')">
                    {{ product['product']['cb_category']['category_name'] }}</h4>
                <a [routerLink]="getRouterLink(product)" [attr.href]="generateHref(product)" (click)="goToProduct(product, 'parent')" class="title text-truncate hand">
                    {{product['product']['description']}}
                </a>
            </ng-container>
            <div fxLayout="row" (click)="goToProduct(product, 'parent')"
                fxLayoutAlign="space-between center" class="prices hand">
                <div fxLayout="row" fxLayoutAlign="center center" class="hand">
                    <p class="new-price hand">
                        {{store['currency']}}{{product['product'].retail_price | number: '1.2-2'}}</p>
                    <span class="perLb"
                        *ngIf="!!product['product']['cb_unit_of_measurement'] && product['product']['cb_unit_of_measurement']['acronym'] === 'lbs'">(Per lb) </span>
                    <p class=" text-muted pd-l-5  hand" *ngIf="product['product'].compare_price"><span
                            class="old-price">{{store['currency']}}{{product['product'].compare_price | number: '1.2-2'}}</span>
                        Saved ({{product['product'].savepercentage}}%)</p>
                </div>
                <div fxLayout="column" fxLayoutAlign="center start">
                    <!-- <p class="pd-5"><span class="">Large / 12</span>lbs</p> -->
                    <p class="pd-5"><span class="">{{product['product']['size']}} <span>{{ !!product['product']['size'] && !!product['product']['weight'] ? '/' : '' }}</span> {{product['product']['weight']}}</span></p>

                </div>
            </div>
            <div class="divider"></div>
            <div class="icons">
                <app-controls [store]="store" [product]="product" (onOpenProductDialog)="openProductDialog(product)">
                </app-controls>
            </div>
        </mat-card>
    </div>

</div>


<!-- Products Dialog Popup -->
<ng-template #productDialog let-data class="product-dialog">
    <div class="close-btn-outer">
        <button mat-mini-fab color="warn" (click)="close()"><i class="material-icons" data-icon="close"></i></button>
    </div>
    <div mat-dialog-content class="quick-flow">
        <div fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="25">
                <mat-chip-list>
                    <mat-chip color="warn" class="design" selected="true" *ngIf="!!data['product']['featured_product']">
                        FEATURED</mat-chip>
                    <mat-chip class="newItem design" selected="true" *ngIf="!!data['product']['new_arrival']">NEW!
                    </mat-chip>
                </mat-chip-list>
                <div class="swiper-container h-100" [swiper]="productConfig">
                    <div class="swiper-wrapper">
                        <div *ngFor="let image of data.images" class="swiper-slide">
                            <img src="data:," [imgName]="image.medium" imgType="products" imgSize="md"
                                class="swiper-lazy" ngClass.lt-md="sm" imagePreload
                                alt="{{data['product']['description']}}" />
                            <div class="swiper-lazy-preloader"></div>
                        </div>
                    </div>
                    <button mat-icon-button class="swiper-button-prev swipe-arrow">
                        <mat-icon>keyboard_arrow_left</mat-icon>
                    </button>
                    <button mat-icon-button class="swiper-button-next swipe-arrow">
                        <mat-icon>keyboard_arrow_right</mat-icon>
                    </button>
                </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="75" ngClass.gt-sm="px-2 m-0" ngClass.sm="mt-2" ngClass.xs="mt-2">
                <h2>{{data['product']['description']}}</h2>
                <div class="py-1 lh">
                    <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_show_two_line_description_in_product_card']">
                        <p class="category-producer">
                            <span class="categoryConaiter">
                                <span class="text-muted fw-500">Category: </span>
                                <span>{{ data['product']['cb_category']['category_name'] }}</span>
                            </span>
                            <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_manufacturer_list']">
                                <span class="producerConaiter" *ngIf="!!data['product'] && (data['product']['manufacturer_name'] || data['product']['vendor_name'])">
                                    <span class="text-muted fw-500">Producer: </span>
                                    <span>{{ data['product']['manufacturer_name'] || data['product']['vendor_name'] }}</span>
                                </span>
                            </ng-container>
                            <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_manufacturer_list']">
                                <span class="producerConaiter" *ngIf="!!data['product']['vendor_name']">
                                    <span class="text-muted fw-500">Producer: </span>
                                    <span>{{ data['product']['vendor_name'] }}</span>
                                </span>
                            </ng-container>
                        </p>
                    </ng-container>
                    <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_show_two_line_description_in_product_card']">
                        <p>
                            <span class="text-muted fw-500">Category: </span>
                            <span>{{ data['product']['cb_category']['category_name'] }}</span>
                        </p>
                    </ng-container>
                </div>
                <!-- <p class="py-1 text-muted lh description"
                    [innerHTML]="data['product']['website_description'] | sanitizeHtml"></p> -->
                    <p class="py-1 text-muted lh description" id="quickViewDes">
                        <span>{{  productDescription | limitWords }}</span>
                    </p>
                <!-- <div fxLayoutAlign="end center" class="text-muted" *ngIf="storeDetailsJson['settings']">                 
                    <button *ngIf="storeDetailsJson['settings']['productFullView'] === true" 
                        [mat-dialog-close]="product" mat-icon-button matTooltip="View full details">
                        <mat-icon>arrow_forward</mat-icon>
                    </button>               
                </div> -->
                <div class="divider" fxShow="false" fxShow.gt-sm="true"></div>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxShow="false" fxShow.gt-sm="true"
                    class="prices mt-1">
                    
                    <ng-container *ngIf="!!featureTags && featureTags['pdp_button_change']; else buttonChangePartOne">
                    <div class="priceRow">
                        <h2 class="mt-1 new-price">
                            {{store['currency']}}{{data['product']['retail_price'] | number: '1.2-2'}}
                        </h2>
                        <span class="perLb-big mt-1" style="line-height: normal;"
                            *ngIf="!!data['product']['cb_unit_of_measurement'] && data['product']['cb_unit_of_measurement']['acronym'] === 'lbs'">(Per lb)
                        </span>
                        <p class="mt-1 greyText pd-5" *ngIf="!!data['product'].compare_price"><span
                                class="old-price">{{store['currency']}}{{data['product'].compare_price | number : '1.2-2'}}
                            </span> <span class="savedPercentage">Saved ({{data['product'].savepercentage}}%)</span></p>
                    </div>
                        <app-controls *ngIf="data" [type]="'dialog'" [product]="data" [store]="store" [fullBtn]="true"></app-controls>
                    </ng-container>
                    <ng-template #buttonChangePartOne>
                        <div fxLayout="row" fxLayoutAlign="center start">
                            <h2 class="mt-1 new-price">
                                {{store['currency']}}{{data['product']['retail_price'] | number: '1.2-2'}}
                            </h2>
                            <span class="perLb-big"
                                *ngIf="data['product']['cb_unit_of_measurement']['acronym'] === 'lbs'">(Per lb)
                            </span>
                            <p class="mt-1 text-muted pd-5" *ngIf="!!data['product'].compare_price"><span
                                    class="old-price">{{store['currency']}}{{data['product'].compare_price | number : '1.2-2'}}
                                </span> Saved ({{data['product'].savepercentage}}%)</p>
                        </div>
                        <app-controls *ngIf="data" [type]="'dialog'" [product]="data" [store]="store"></app-controls>
                    </ng-template>
                </div>

            </div>
        </div>
    </div>
    <div mat-dialog-actions fxShow="false" fxShow.lt-md="true">
        <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center" class="productDialog prices">
            <ng-container *ngIf="!!featureTags && featureTags['pdp_button_change']; else buttonChangePartOne">
                <div fxLayout="column" fxLayoutAlign="center start">
                    <p class="mt-1 text-muted pd-5" *ngIf="!!data['product'].compare_price"><span
                            class="old-price">{{store['currency']}}{{data['product'].compare_price | number : '1.2-2'}}
                        </span> <span class="savedPercentage">Saved ({{data['product'].savepercentage}}%)</span></p>
                    <h2 class="new-price">{{store['currency']}}{{data['product']['retail_price'] | number: '1.2-2'}}
                        <span *ngIf="!!data['product']['cb_unit_of_measurement'] && data['product']['cb_unit_of_measurement']['acronym'] === 'lbs'"
                            class="perLb-big" style="line-height: normal;">(Per
                            lb) </span>
                    </h2>
                </div>
                <div fxLayout="column" fxLayoutAlign="center start">                
                        <app-controls *ngIf="data" [type]="'dialog'" [product]="data" [fullBtn]="true"
                        [store]="store">
                        </app-controls>
                </div>
            </ng-container>
            <ng-template #buttonChangePartOne>
                <div fxLayout="column" fxLayoutAlign="center start">
                    <p class="mt-1 text-muted pd-5" *ngIf="!!data['product'].compare_price"><span
                            class="old-price">{{store['currency']}}{{data['product'].compare_price | number : '1.2-2'}}
                        </span> Saved ({{data['product'].savepercentage}}%)</p>
                    <h2 class="new-price">{{store['currency']}}{{data['product']['retail_price'] | number: '1.2-2'}}
                        <span *ngIf="data['product']['cb_unit_of_measurement']['acronym'] === 'lbs'"
                            class="perLb-big">(Per
                            lb) </span>
                    </h2>
                </div>
                <div fxLayout="column" fxLayoutAlign="center start">
                <app-controls *ngIf="data" [type]="'dialog'" [product]="data"
                [ngStyle]="{'margin-top': !!data['product'].compare_price ? '15px': ''}" [store]="store">
                </app-controls>
                </div>
            </ng-template>
                

        </div>
    </div>
</ng-template>